// Photo catalog: parts shown as pictures by category (fittings, bulbs, filters…) — tap the one that looks right.
// For the small parts nobody remembers the number of.
import { useMemo, useState } from 'react';
import { photoSrc, type Row } from '../lib';
import { qtyUom } from '../../shared/units';
import { partPhotos } from './Inventory';

export function PhotoCatalog({ parts, onPick, startCategory, showStock = true }: { parts: Row[]; onPick: (p: Row) => void; startCategory?: string; showStock?: boolean }) {
  const withPhoto = useMemo(() => parts.filter(p => partPhotos(p).length), [parts]);
  const cats = useMemo(() => [...new Set(withPhoto.map(p => String(p.category || '')).filter(Boolean))].sort(), [withPhoto]);
  const [cat, setCat] = useState<string>(() => {
    const want = startCategory ? cats.find(c => c.toLowerCase().includes(startCategory.toLowerCase())) : '';
    return want || '';
  });
  const list = withPhoto.filter(p => !cat || p.category === cat);
  if (!withPhoto.length) return <p className="muted pad">No part photos yet. Add photos to parts in Inventory (edit a part → Part photos) — fittings, bulbs, filters — and they show here as pictures to tap.</p>;
  return (
    <div className="catalog">
      {cats.length > 0 && <div className="chip-row cat-chips">
        <button type="button" className={'chip' + (!cat ? ' on' : '')} onClick={() => setCat('')}>All ({withPhoto.length})</button>
        {cats.map(c => <button key={c} type="button" className={'chip' + (cat === c ? ' on' : '')} onClick={() => setCat(c)}>{c} ({withPhoto.filter(p => p.category === c).length})</button>)}
      </div>}
      <div className="cat-grid">
        {list.slice(0, 120).map(p => (
          <button key={p.id} type="button" className="cat-card" onClick={() => onPick(p)}>
            <img src={photoSrc(partPhotos(p)[0])} alt="" loading="lazy" />
            <b>{p.name}</b>
            <small>{p.sku}{p.bin ? ` · bin ${p.bin}` : ''}</small>
            {showStock && p.track_qty !== 0 && <small className={p.stock <= 0 ? 'danger' : 'muted'}>{qtyUom(p.stock, p.uom)} on hand</small>}
          </button>))}
      </div>
    </div>
  );
}
